/* unplugin-vue-components disabled */import { render } from "./seek.vue?vue&type=template&id=532fb1b4&scoped=true"
import script from "./seek.vue?vue&type=script&lang=js"
export * from "./seek.vue?vue&type=script&lang=js"

import "./seek.vue?vue&type=style&index=0&id=532fb1b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532fb1b4"]])

export default __exports__